 import TopMenu from "../../../TopMenu";
import MainDashboardLayout from "../../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../../Layout/DocumentationSidebar";
import React, { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { get } from "../../../../../utils/api";
import { companyId } from "../../../../../utils/companyId";
import TableDocument from "../../../TableDocument";
import FilterModal from "../../../../../Components/Common/FilterModal";
import Unauthorized from "../../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../../context/AuthContext";

const Main = () => {
  const { user } = useUser();

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const [selectedOption, setSelectedOption] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isShortContent, setIsShortContent] = useState(false);
  const [selectedFacility, setSelectedFacility] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit] = useState(10); // Number of items per page
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [errors, setErrors] = useState({});
  const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  const [selectedYear, setSelectedYear] = useState(""); // Stores the selected year
  const [uniqueValues, setUniqueValues] = useState({});
  const [filterObj, setFilterObj] = useState({});
  const [filterOptions, setFilterOptions] = useState({});
  const [columnWidth, setcolumnWidth] = useState(
    user?.companyAdmin
    ? "12% 12% 14% 14% 12% 13% 12% 8%"
    : "12% 16% 16% 16% 15% 12% 8%"
  );

  
  const [url, setUrl] = useState(
    "/in-house-offset-project/documents"
  );
  const [Doc, SetDoc] = useState([]);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  useEffect(() => {
    fetchData();
  }, [
    page,
    rowsPerPage,
    searchQuery,
    url,
    filterObj,
    fromDate,
    toDate,
    selectedFacility,
  ]);

  const fetchData = async (filters = filterObj) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
        company: companyId,
        createdBy: companyId,
        search: searchQuery,
        facilityList: selectedFacility.join(","),
      }).toString();
      const response = await get(
        `/scope4${url}?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`
      );
      setData(response.data.data); // Update the user list
      SetDoc(response.data.data);
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const toggleData = [
    {
      title: "In-House Offset Projects",
      url: "/in-house-offset-project/documents",
    },
    {
      title: "Offset Credit Purchase Tracking",
      url: "/off-set-credit-purchase/documents",
    },
  ];

  const heading = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      title: "Project name",
      key: "projectName",
    },
    {
      title: "Project Type",
      key: "projectType",
    },
    {
      title: "Project Location",
      key: "projectLocation",
    },
    {
      title: "Carbon sequestered annually (tCO₂e)",
      key: "carbonSequesteredAnnually",
    },
    {
      title: "Verification status",
      key: "verificationStatus",
    },
  ].filter(Boolean);

  const heading2 = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      title: "Vendor",
      key: "vendorRegistry",
    },
    {
      title: "Project ID/ Name",
      key: "projectIdOrName",
    },
    {
      title: "Project Type",
      key: "projectType",
    },
    {
      title: "No. of credits purchased (tCO₂e)",
      key: "creditsPurchased",
    },
  ].filter(Boolean);

  const [toggleHeding, SetHeading] = useState(heading);
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const tableContainerRef = useRef(null); // Reference to the table container

  const fetchUniqueValues = async () => {
    try {
      const response = await get(`/scope4${url}`);
      const data = response.data.data;

      const uniqueProjectName = [
        ...new Set(
          data.map((el) => el.projectName).filter(Boolean) // Filter out undefined values
        ),
      ];
      const uniqueProjectType = [
        ...new Set(
          data.map((el) => el.projectType).filter(Boolean) // Filter out undefined values
        ),
      ];
      const uniqueProjectLocation = [
        ...new Set(
          data.map((el) => el.projectLocation).filter(Boolean) // Filter out undefined values
        ),
      ];
      const uniqueVerificationStatus = [
        ...new Set(
          data.map((el) => el.verificationStatus).filter(Boolean) // Filter out undefined values
        ),
      ];
      const uniqueVendorRegistry = [
        ...new Set(
          data.map((el) => el.vendorRegistry).filter(Boolean) // Filter out undefined values
        ),
      ];

      setFilterOptions({
        projectName: uniqueProjectName,
        projectType: uniqueProjectType,
        projectLocation: uniqueProjectLocation,
        verificationStatus: uniqueVerificationStatus,
        vendorRegistry: uniqueVendorRegistry,
      });
      return {
        projectName: uniqueProjectName,
        projectType: uniqueProjectType,
        projectLocation: uniqueProjectLocation,
        verificationStatus: uniqueVerificationStatus,
        vendorRegistry: uniqueVendorRegistry,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Month of energy export",
      type: "date",
      key: "consumptionPeriod",
      value: [],
    },
    {
      title: "Project Type",
      type: "option",
      key: "projectType",
      value: filterOptions.projectType,
    },
    {
      title: "Verification Status",
      type: "option",
      key: "verificationStatus",
      value: filterOptions.verificationStatus,
    },
  ];

  const filterData2 = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Project Type",
      type: "option",
      key: "projectType",
      value: filterOptions.projectType,
    },
    {
      title: "Vendor Registry",
      type: "option",
      key: "vendorRegistry",
      value: filterOptions.vendorRegistry,
    },
  ];

  const handleFilterChange = (newFilterObj) => {
    if (selectedOption === "In-House Offset Projects") {
      setFilterObj((prev) => ({
        ...prev,
        ...newFilterObj,
      }));
    } else {
      setFilterObj((prev) => ({
        ...prev,
        ...newFilterObj,
      }));
    }

    console.log("Applied Filters:", newFilterObj);
  };

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 3);
    }
  }, [data]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleToggle = (option, url) => {
    setSelectedOption(option);
    setUrl(url);
    SetHeading(toggleData?.[0]?.title === option ? heading : heading2);
    setcolumnWidth(
      toggleData?.[0]?.title === option
        ? user?.companyAdmin
          ? "12% 12% 14% 14% 12% 13% 12% 8%"
          : "12% 16% 16% 16% 15% 12% 8%"
        : user?.companyAdmin
        ? "12% 14% 13% 17% 16% 17% 8%"
        : "12% 15% 16% 20% 25% 8%"
    );
  };

  useEffect(() => {
    setSelectedOption(toggleData?.[0].title);
    setUrl(toggleData?.[0].url);
  }, []);

  return (
    <MainDashboardLayout sidebar={<DocumentationSidebar />}>
      <Unauthorized requiredModule="Documentation | Scope 4 | Carbon Offset">
        <>
          <TopMenu
            {...{
              setDrawerFilterOpen: setIsFilterModalOpen,
              selectedMonth,
              setSelectedMonth,
              selectedYear,
              setSearchQuery,
              setSelectedYear,
              selectedOption,
              handleToggle,
              filterApplied: isFilterModalOpen,
              toggleData,
              fromDate,
              setFromDate,
              toDate,
              setToDate,
              selectedFacility,
              setSelectedFacility,
            }}
            heading={"Carbon Offset"}
          />
          <Box
            sx={{
              backgroundColor: "#ededed",
            }}
          >
            <TableDocument
              data={Doc}
              totalPages={totalPages}
              headers={toggleHeding}
              columnWidth={columnWidth}
              tableContainerRef={tableContainerRef}
            />
          </Box>
          <FilterModal
            isOpen={isFilterModalOpen}
            onClose={() => setIsFilterModalOpen(false)}
            filters={
              selectedOption === "In-House Offset Projects"
                ? filterData
                : filterData2
            }
            onFilterChange={handleFilterChange}
            title="Filter"
          />
        </>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Main;
